import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import ProductCompactList from "../components/ProductCompactList";

// Parent route element for the Product master-detail split - third module on
// this pattern after Employee Master and Customers. See AppRoutes.jsx for
// how index/new/:recordGuid/edit nest under this instead of being flat,
// full-page routes. Product Groups stays a normal flat page - it's not a
// per-product detail view.
const ProductSplitView = () => <MasterDetailLayout list={<ProductCompactList />} />;

export default ProductSplitView;
